export const appointmentStatus: any = {
  pending: "Upcoming",
  cancelled: "Cancelled",
  completed: "Completed",
  clientrejected: "Client Rejected",
  noshow: "No Show",
  canceled:"Cancelled"
};


export const attendenceStatus: any = {
  present: "Present",
  leave: "Leave",
};

export const storeStatus = [{label:"Open", value:"open"}, {label:"Closed", value:"closed"}];